import { cn } from '@/lib/utils';
import type { RoadmapStatus, RoadmapSubmodule } from '../types';

interface Props {
  submodule: RoadmapSubmodule;
}

const STATUS_DOT: Record<RoadmapStatus, string> = {
  live: 'bg-capitol-red-500 shadow-[0_0_0_3px_rgba(237,28,36,0.15)]',
  'in-progress': 'bg-warning shadow-[0_0_0_3px_rgba(251,191,36,0.20)]',
  planned: 'bg-capitol-gray-300',
};

const STATUS_BG: Record<RoadmapStatus, string> = {
  live: 'border-capitol-red-100 bg-capitol-red-50/50 hover:border-capitol-red-200',
  'in-progress': 'border-warning/30 bg-warning/10 hover:border-warning/50',
  planned: 'border-capitol-gray-200 bg-capitol-gray-50 hover:border-capitol-gray-300',
};

export function SubmoduleChip({ submodule }: Props) {
  const Icon = submodule.icon;
  return (
    <div
      className={cn(
        'group/chip flex items-center gap-3 rounded-lg border bg-card p-3 transition-all duration-200 hover:-translate-y-px hover:shadow-sm',
        STATUS_BG[submodule.status]
      )}
    >
      {Icon && (
        <span
          className={cn(
            'flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-card text-capitol-gray-500 ring-1 ring-capitol-gray-200 transition-colors group-hover/chip:text-capitol-red-500'
          )}
        >
          <Icon className="h-4 w-4" />
        </span>
      )}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className="font-mono text-[10px] uppercase tracking-wider text-capitol-gray-400">
            {submodule.code}
          </span>
          <span aria-hidden className={cn('h-1.5 w-1.5 rounded-full', STATUS_DOT[submodule.status])} />
        </div>
        <p className="truncate text-sm font-medium text-capitol-gray-500">{submodule.name}</p>
      </div>
    </div>
  );
}
